export default "__VITE_ASSET__F_Ee3MS8__"